export default (value) => {
  if (value !== 'not-set') return value

  return null
}
